<!-- 签到审批页面 -->
<template>
  <div class="main-content">
    <van-nav-bar
      id="titlebar"
      title="签到审批"
      left-arrow
      @click-left="onClickLeft"
    >
    </van-nav-bar>
    <div class="content">
      <div id="div-map"></div>
      <van-field
        v-model="signInfo.signAddress"
        rows="1"
        type="textarea"
        autosize
        label-width="50"
        label="地址"
        readonly
        right-icon="location-o"
        placeholder=""
      />
      <!--  -->
      <van-field
        v-model="signInfo.signRemark"
        rows="3"
        type="textarea"
        autosize
        label-width="50"
        label="备注"
        :border="true"
        placeholder="请填写备注"
        label-align="top"
      />
      <div
        style="
          display: flex;
          flex-direction: column;
          padding: 10px 20px;
          gap: 10px;
          background-color: #fff;
        "
      >
        <span>签到图片</span>
        <van-uploader
          v-model="fileList"
          :deletable="false"
          multiple
          :max-count="6"
          disabled
        >
          <!-- <template><span></span></template> -->
        </van-uploader>
      </div>

      <van-row
        v-if="signInfo.signStatus === 0"
        justify="center"
        gutter="15"
        style="margin: 20px 10px 0px"
      >
        <van-col span="12">
          <van-button block type="primary" @click="requestAudit(1)">
            同意
          </van-button>
        </van-col>
        <van-col span="12">
          <van-button block type="primary" @click="requestAudit(2)">
            拒绝
          </van-button>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import AMapLoader from "@amap/amap-jsapi-loader";
import { getSignInfo, signApprove } from "@/api/sign";
import { closeToast, showLoadingToast } from "vant";

const signInfo = ref({});
const fileList = ref([]);
let map = null;

// 同意 / 拒绝
const requestAudit = (type) => {
  showLoadingToast({
    message: "正在审批...",
    duration: 0,
  });
  // 到状态，0:待审核，1:审核通过，2:审核拒绝
  signApprove({ signInId: signInfo.value.signInId, signStatus: type })
    .then(() => {
      closeToast();
      showSuccessToast("审批成功");
      // 审批成功，返回上个页面
      onClickLeft();
    })
    .catch((error) => {
      console.log("approve ", error);
      closeToast();
      showFailToast(error ?? "审批失败");
    });
};
const route = useRoute();

const onClickLeft = () => {
  history.back();
};
onMounted(() => {
  const signId = route?.params?.signId;
  if (signId) {
    getSignInfo({ signInId: signId }).then((res) => {
      if (res) {
        console.log("signInfo", JSON.stringify(res));
        signInfo.value = res;
        if (signInfo.value?.signImage) {
          fileList.value.push({ url: signInfo.value?.signImage });
        }

        window._AMapSecurityConfig = {
          securityJsCode: "1cd106d13900dd493ac284004811d81b",
        };
        AMapLoader.load({
          key: "fb75cef02a4c2cb59359fbb8ce794739", // 申请好的Web端开发者Key，首次调用 load 时必填
          version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        }).then((AMap) => {
          map = new AMap.Map("div-map", {
            // 设置地图容器id
            // viewMode: "2D", // 是否为3D地图模式
            // resizeEnable: true,
            zoom: 10, // 初始化地图级别
            // center: [
            //   signInfo.value?.signAddressLon ?? 0,
            //   signInfo.value?.signAddressLat ?? 0,
            // ], // 初始化地图中心点位置
          });
          const position = new AMap.LngLat(
            signInfo.value?.signAddressLon,
            signInfo.value?.signAddressLat
          ); //Marker 经纬度
          const marker = new AMap.Marker({
            position: position,
            // content: markerContent, //将 html 传给 content
            // offset: new AMap.Pixel(-13, -30), //以 icon 的 [center bottom] 为原点
          });
          map?.add(marker);
          map?.setCenter(position);
        });
      }
    });
  }
});
</script>

<style scoped>
.main-content {
  width: 100%;
  height: calc(100% - 50px);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  font-size: 14px;
  overflow: hidden;
}

.content {
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: auto;
  background-color: #f6f6f6;
}

#div-map {
  width: 100%;
  height: 200px;
  padding: 0px;
  margin: 0px;
  overflow: hidden;
}
</style>
